<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="30%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="Email" prop="email">
        <el-input v-model="formData.email"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="formData.status" placeholder="请选择状态" filterable>
          <el-option label="未订阅" :key="1" :value="10"></el-option>
          <el-option label="订阅" :key="2" :value="20"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'mail_add',
  props: [
    'visible', 'id'
  ],
  data () {
    return {
      title: '添加邮箱',
      formData: {
        email: '',
        status: 20
      },
      addFormRules: {
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.addFormRef.resetFields()
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑邮箱'
        this.getInfo(this.id)
      } else {
        this.title = '添加邮箱'
      }
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/subscribe/info/' + id)
      if (res.code === 0) {
        this.formData = {
          email: res.data.email,
          status: res.data.status
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
